/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { GoodsDeliveryNoteService } from "services/goods-delivery-note";

function ActionCell({ item, setDataTable }) {
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await GoodsDeliveryNoteService.delete(item._id);
      setDataTable((prev) => ({
        ...prev,
        rows: prev.rows.filter((row) => row.id !== item._id),
      }));
      toast.success("Đã xoá phiếu xuất kho");
    } catch (error) {
      toast.error("Xoá thất bại");
    } finally {
      setDeleting(false);
      setOpen(false);
    }
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <Link to={`/templates/goods-delivery-note/${item._id}/view`}>
        <SoftTypography variant="body1" color="success" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Xem chi tiết" placement="top">
            <Icon>visibility</Icon>
          </Tooltip>
        </SoftTypography>
      </Link>
      <SoftBox mx={2}>
        <Link to={`/templates/goods-delivery-note/${item._id}/edit`}>
          <SoftTypography variant="body1" color="info" sx={{ cursor: "pointer", lineHeight: 0 }}>
            <Tooltip title="Cập nhật" placement="top">
              <Icon>edit</Icon>
            </Tooltip>
          </SoftTypography>
        </Link>
      </SoftBox>
      <SoftTypography
        onClick={() => !deleting && setOpen(true)}
        variant="body1"
        color="error"
        sx={{ cursor: deleting ? "not-allowed" : "pointer", lineHeight: 0, opacity: deleting ? 0.5 : 1 }}
      >
        <Tooltip title="Xóa" placement="left">
          <Icon>delete</Icon>
        </Tooltip>
      </SoftTypography>

      <Dialog open={open} onClose={() => !deleting && setOpen(false)}>
        <DialogTitle>Xóa phiếu xuất kho?</DialogTitle>
        <DialogContent>
          <DialogContentText>Bạn có chắc chắn muốn xóa?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={deleting}>
            Hủy
          </Button>
          <Button onClick={handleDelete} autoFocus disabled={deleting}>
            {deleting ? (
              <>
                <CircularProgress size={16} sx={{ mr: 1 }} />
                Đang xoá...
              </>
            ) : (
              "Đồng ý"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </SoftBox>
  );
}

export default ActionCell;
